<template>
  <v-progress-circular :size="20" indeterminate color="primary" v-if="globalLoading" />
  <div v-else>
    <AdminDashboard v-if="shouldAdminDashboardShow()" />
    <RacerDashboard v-else-if="shouldRacerDashboardShow()" />
    <DistrictManagerDashboard v-else-if="shouldDistrictManagerDashboard()" />
    <SalespersonDashboard v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AdminDashboard from "./admin/AdminDashboard.vue";
import RacerDashboard from "./racer/RacerDashboard.vue";
import SalespersonDashboard from "./salesperson/SalespersonDashboard.vue";
import DistrictManagerDashboard from "./districtManager/DistrictManagerDashboard.vue";

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Dashboard"
  },
  components: { RacerDashboard, SalespersonDashboard, AdminDashboard, DistrictManagerDashboard },
  data: () => ({}),
  mounted() {},
  methods: {
    shouldAdminDashboardShow() {
      return parseInt(this.selectedParticipant.participantType.participantTypeKey) < 170;
    },
    shouldRacerDashboardShow() {
      return this.$kawasaki.isRacer() || this.$kawasaki.isRacerAdmin();
    },
    shouldDistrictManagerDashboard() {
      return this.$kawasaki.isDistrictManager();
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant", "globalLoading"])
  }
};
</script>
